export default () => {
    const inputs = document.querySelectorAll<HTMLInputElement>('input.input-text');

    inputs.forEach((input) => {
        const updateQuantity = () => {
            const quantity = parseInt(input.value || input.getAttribute('value') || '1', 10);
            if (!isNaN(quantity) && quantity > 0) {
                const container = input.closest('li, .woocommerce, .product, .summary') || input.parentElement;
                if (!container) return;

                const addToCartBtn = container.querySelector<HTMLElement>('.wvs-add-to-cart-button');
                if (addToCartBtn) {
                    addToCartBtn.setAttribute('data-quantity', quantity.toString());
                }
            }
        };

        input.addEventListener('input', updateQuantity);
        input.addEventListener('change', updateQuantity);

        const plusBtn = input.parentElement?.querySelector('.ux-quantity__button--plus');
        const minusBtn = input.parentElement?.querySelector('.ux-quantity__button--minus');

        [plusBtn, minusBtn].forEach((btn) => {
            btn?.addEventListener('click', () => {
                // Let the click update the input first, then read its new value
                setTimeout(updateQuantity, 0);
            });
        });
    });
}